import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, message, Divider, Table, Input, Tooltip, Space, Tag } from "antd";
import { SearchOutlined, ReadOutlined, FileDoneOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import http from "../../../services/http";

export const TreinamentosLancamentoGrupos = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  // ID ALTERAÇÃO
  const [search, setSearch] = useState("");

  useEffect(() => {
    listarGrupos();
  }, []);

  // LISTAR
  const listarGrupos = async () => {
    setLoading(true);
    const api = await http("get", `v1/treinamentos_grupos/listar_ativos`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Descrição",
      dataIndex: "descricao",
      sorter: (a, b) => a.descricao?.localeCompare(b.descricao),
    },
    {
      title: "Pendêntes",
      dataIndex: "total_cursos",
      render: (_, e) => (e?.total_cursos > 0 ? <Tag color="red">{e?.total_cursos}</Tag> : "-"),
      sorter: (a, b) => a.descricao?.localeCompare(b.descricao),
    },
    {
      title: "Ações",
      width: 150,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Treinamentos">
            <Button
              loading={loading}
              onClick={() => navigate(`/treinamentos/lancamento/grupos/cursos/${e?.id}`)}
              icon={<ReadOutlined />}
            />
          </Tooltip>
        </Space.Compact>
      ),
      dataIndex: "acoes",
    },
  ];

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter((val) => val.descricao?.toLowerCase().includes(pesquisar.toLowerCase()));
    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Treinamentos & Desenvolvimento" onClickBack={() => navigate("/")} />
            <HeaderTitle
              title={["Treinamentos & Desenvolvimento", "Grupos"]}
              subtitle="Realizar treinamentos"
              icon={<ReadOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
                <Button
                  type="primary"
                  icon={<FileDoneOutlined />}
                  onClick={() => navigate("/treinamentos")}
                  loading={loading}>
                  Histórico de Treinamentos
                </Button>
              </Space>

              <Divider />

              <Table
                rowKey="id"
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
